import React from 'react';
import MyPostsView from './MyPosts';

export default MyPostsView;
